import BaseViewController from "../base-view-controller";

class AboutYouEditViewController extends BaseViewController {
  preprocessScreenData() {
    if (!("race" in this.appData.values)) {
      const raceField = this.screen.fields.find(f => f.name === "race");
      const ethnicityField = this.screen.fields.find(
        f => f.name === "ethnicity"
      );

      if (
        typeof raceField !== "undefined" &&
        typeof ethnicityField !== "undefined"
      ) {
        raceField.options = raceField.options.map(o => {
          return { ...o, value: o.value.toString() };
        });
        ethnicityField.options = ethnicityField.options.map(o => {
          return { ...o, value: o.value.toString() };
        });

        this.appData.handleChange({
          race: raceField.options
            .find(o => o.selected === true)
            ?.value?.toString(),
          ethnicity: ethnicityField.options
            .find(o => o.selected === true)
            ?.value?.toString()
        });
      }
    }
    super.preprocessScreenData();
  }
}

export default AboutYouEditViewController;
